var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBucket = function SvgBucket(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M14 6.992h3.008V8H16v8.992L15.008 18H8l-.992-1.008V8H6V6.992h3.008V6q0-.416.288-.704A.93.93 0 0 1 10 4.992h3.008q.4.016.688.304A.93.93 0 0 1 14 6zM13.008 6H10v.992h3.008zM8 16.992h7.008V8H8zm2-8h-.992V16H10zm1.008 0H12V16h-.992zm2 0H14V16h-.992z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBucket);
export { ForwardRef as ReactComponent };